import { lazy } from 'react';

import { RoutesConfigType } from '@src/lib/types';

const ComingSoon = lazy(() => import('@src/screens/ComingSoon'));

const gateRoutes: Array<RoutesConfigType> = [{ path: '/gate', component: ComingSoon, layout: 'private' }];

export default gateRoutes;
